import { useEffect, useRef } from "react";
import Blobity, { Options } from "./Blobity.js";

const useBlobity = (options: Partial<Options>) => {
  const instance = useRef<Blobity | null>(null);

  useEffect(() => {
    if (!instance.current) {
      instance.current = new Blobity(options);
    }

    return () => {
      if (instance.current) {
        instance.current.destroy();
        instance.current = null;
      }
    };
  }, [options]);

  return instance;
};

export default useBlobity;
